import { Signal } from '@angular/core';

export interface DialogConfig {
  type: DialogType;
  title: string;
  iconName?: string;
  contentLabel?: string;
  contentVariant?: DialogInfoVariant;
  buttonConfig?: DialogButtonConfig[];
}

export enum DialogType {
  SHARE = 'SHARE',
  CANCEL = 'CANCEL',
  DELETE = 'DELETE',
  UNSHARE = 'UNSHARE',
  SHOW_ROUTE = 'SHOW_ROUTE',
}

export type DialogInfoVariant = 'danger' | 'info';

export interface DialogButtonConfig {
  label: string;
  cssClass: string;
  passData?: boolean;
  loading?: Signal<boolean>;
  closeOnClick?: boolean;
  action?: DialogType;
}
